import React from 'react';

const Home = () => {
  return (
    <div className="text-center mt-3 mb-5" style={{minHeight:'80vh'}}>
      <h1 className='text-center'>Welcome to Quiz App</h1>
      <p className='text-center'>
        This is a quiz application that allows you to generate quiz questions,
        take quizzes, and receive feedback on your performance.
      </p>
      <p className='text-center'>
        Get started by using the navigation links in the header to generate
        questions or take a quiz!
      </p>
    </div>
  );
};

export default Home;
